import React, { FC } from 'react';
import { useNavigate } from 'react-router';
import useLocales from 'hooks/useLocales';
import Navbar from 'components/Navbar';
import Image from 'components/image/Image';
import Footer from 'components/Footer/Index';
import UpgradePlanPopup from 'components/shared/Popups/UpgradePlan/Index';
import { COMPANY_DEFAULT_ROUTE } from 'core/constants/companyRoutes';

import './Index.scss';

const CompanyPlans: FC = (): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useLocales();

  return (
    <div className="company-plans-page">
      <Navbar />
      <div className="company-plans-page__content">
        <div className="navigation_section">
          <div
            className="back_button skillio-back-button"
            onClick={() => navigate(COMPANY_DEFAULT_ROUTE)}
          >
            <Image name="arrow-left.svg" />
            {t('Back')}
          </div>
        </div>
        <div className="company-plans-page__header">
          <h1 className="company-plans-page__title">{t('Upgrade your plan')}</h1>
          <p className="company-plans-page__description">
            {t('Your subscription plan determines how many profiles you can unlock, how many new jobs you can post and how many AI credits you can use each month. Once you use up these credits, they won’t be replenished - even if you delete a job post. Any unused credits at the end of your billing cycle will roll over to the next month, so you don’t lose them.')}
          </p>
        </div>
        <div className="main_section">
          <UpgradePlanPopup t={t} asPage />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CompanyPlans;
